<template>
  <shopping-list />
</template>

<script>
import Vue from "vue";
import ShoppingList from "@/components/ShoppingList";

export default Vue.extend({
  name: "shoppinglist",
  data: function () {
    return {};
  },

  components: {
    ShoppingList,
  },
});
</script>
